// extracted by mini-css-extract-plugin
export default {"con-dialog-content":"UYpmo1_E"};